<template>
  <div>
    <Card shadow>
      <Row :gutter="24">
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">代理:</span>
            <Select
              v-model="table.params.app_id"
              filterable
              placeholder="筛选代理"
              :max-tag-count="3"
              clearable
            >
              <Option
                v-for="(item, index) in app_list"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">商户:</span>
            <Select
              v-model="table.params.general_id"
              filterable
              placeholder="筛选 商户"
              :max-tag-count="3"
              @on-change="updateGeneral"
              clearable
            >
              <Option
                v-for="(item, index) in select.general_list"
                :value="item.general"
                :label="item.general_name"
                :key="index"
              >
                {{ item.general_name }}
                <span style="color: #bbb">({{ item.general }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 80px">子商户:</span>
            <Select
              v-model="table.params.pack_no"
              filterable
              placeholder="筛选 子商户"
              clearable
            >
              <Option
                v-for="(item, index) in getPackList()"
                :value="item.pack_no"
                :label="item.pack_name"
                :key="index"
              >
                {{ item.pack_name }}
                <span style="color: #bbb">({{ item.pack_no }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">玩家ID:</span>
            <Input
              v-model="table.params.user_id"
              placeholder="请输入玩家ID"
              clearable
            ></Input>
          </label>
        </Col>
      </Row>

      <Row :gutter="24" style="margin-top: 20px">
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">三方账号:</span>
            <Input
              v-model="table.params.external_account"
              placeholder="请输入三方账号"
              clearable
            ></Input>
          </label>
        </Col>
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">订单状态:</span>
            <Select
              v-model="table.params.transfer_status"
              filterable
              placeholder="选择订单状态"
              clearable
            >
              <Option
                v-for="item in select.transferStatus"
                :value="item.value"
                :label="item.name"
                :key="item.value"
              >
                {{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>

        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">操作类型:</span>
            <Select
              v-model="table.params.transfer_type"
              filterable
              placeholder="选择操作类型"
              clearable
            >
              <Option
                v-for="item in select.transfer_type"
                :value="item.value"
                :label="item.name"
                :key="item.value"
              >
                {{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>

        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">三方单号:</span>
            <Input
              v-model="table.params.external_order_id"
              placeholder="三方单号"
              clearable
            ></Input>
          </label>
        </Col>
        <!-- <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">上级Id:</span>
            <Input
              v-model="table.params.pid"
              placeholder="上级Id"
              clearable
            ></Input>
          </label>
        </Col> -->
        <!-- <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">游戏类型:</span>
            <Select
              v-model="table.params.gtype"
              filterable
              placeholder="选择游戏类型"
              clearable
            >
              <Option
                v-for="item in select.GameType_List"
                :value="item.value"
                :label="item.name"
                :key="item.value"
                >{{ item.name }}</Option
              >
            </Select>
          </label>
        </Col> -->
      </Row>
      <Row :gutter="24" style="margin-top: 20px">
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">单号:</span>
            <Input
              v-model="table.params.bill_no"
              placeholder="单号"
              clearable
            ></Input>
          </label>
        </Col>
        <Col span="10">
          <label style="display: flex; align-items: center">
            <span style="width: 140px">时间范围:</span>
            <DatePicker
              type="daterange"
              v-model="table.params.dataTime"
              placeholder="统计时间"
              :options="dateOptions"
              style="width: 100%"
            ></DatePicker>
            <span class="tips">注： 时间范围不允许跨月</span>
          </label>
        </Col>
      </Row>
      <Row style="margin-top: 20px">
        <Col span="4" style="display: flex; justify-content: space-between">
          <Button type="primary" @click.native="searchData(true)">查询</Button>
          <div>
            <Button type="primary" @click.native="eleToExcel()"
              >导出excel</Button
            >
          </div>
        </Col>
      </Row>
    </Card>
    <Table
      border
      :columns="table.columns"
      :data="table.data"
      style="margin-top: 12px"
      :max-height="tableMaxHeight"
      ref="tableRef"
    ></Table>
    <Page
      style="margin-top:10px;"
      :total="page.total"
      show-total
      :current="page.currentPage"
      :page-size-opts="page.pageSizes"
      :page-size="page.pageSize"
      show-sizer
      @on-page-size-change="pageSizeChange"
      @on-change="pageChange"
    ></Page>
  </div>
</template>

<script>
import MulReportHeader from './components/mul_report_header.vue'
import { TransTopReq } from '@/api/admin/risk'
export default {
  name: 'TransferReport',
  components: { MulReportHeader },
  tableMaxHeight: 0,
  data() {
    return {
      loading: false,
      TransTopReqTimer: null,
      timestamp: 0,
      select: {
        general_list: [],
        pack_list: []
      },
      all: {},
      select: {
        GameType_List: JSON.parse(localStorage.getItem('gameList')),
        transfer_type: [
          { name: '全部', value: -1 },
          { name: '转入', value: 1 },
          { name: '转出', value: 2 }
        ],
        transferStatus: [
          { name: '成功', value: 1 },
          { name: '失败', value: 2 },
          { name: '划转中', value: 3 }
        ]
      },
      //活动数据
      // GetZhuanPanActiveData
      table: {
        app_name: '',
        gp_name: '',
        params: {
          general_id: -1,
          transfer_status: -1,
          transfer_type: -1,
          platid: -1,
          app_id: -1,
          pack_no: -1,
          external_order_id: '',
          bill_no: '',
          user_id: '',
          user_name: '',
          external_account: '',
          dataTime: [
            new Date(
              this.getCurrentZeroDay().getTime() - 6 * 24 * 60 * 60 * 1000
            ),
            this.getCurrentZeroDay()
          ]
        },
        data: [],
        columns: [
          this.getRenderColumn('user_name', '玩家名称', '显示玩家的名称'),
          this.getRenderColumn('user_id', '玩家ID', '显示玩家的ID'),
          this.getRenderColumn(
            'external_account',
            '三方账号',
            '显示三方过来的玩家账号'
          ),
          this.getRenderColumn('bill_no', '划转单号', '显示划转单号'),
          this.getRenderColumn('order_id', '单号', '单号'),
          this.getRenderColumn(
            'transfer_type',
            '操作类型',
            '显示操作类型，包括：转入，转出两种'
          ),
          this.getRenderColumn(
            'external_order_id',
            '三方订单号',
            '显示三方订单号'
          ),
          this.getRenderColumn(
            'old_point',
            '转前额度',
            '转账前玩家在B端内的资金'
          ),
          this.getRenderColumn('chang_point', '划转金额', '显示划转的具体金额'),
          this.getRenderColumn(
            'new_point',
            '转后额度',
            '转账后玩家在B端内的资金'
          ),
          {
            key: 'transfer_status',
            title: '订单状态',
            width: 120,
            align: 'center',
            resizable: true,
            render: (h, params) => {
              const colorMap = {
                '1': 'green',
                '2': 'red',
                '3': '#ddd'
              }
              const { row } = params
              const status = this.select.transferStatus.filter(
                item => item.value == row.transfer_status
              )[0]

              return h(
                'span',
                { style: { color: colorMap[status.value] } },
                status.name
              )
            },
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '订单状态',
                '显示订单状态，包括：成功，失败，划转中三种'
              )
          },
          this.getRenderColumn('time', '划转时间', '显示划转的时间')
        ]
      },
      page: {
        total: 0,
        totalSum: 0,
        pageSize: 15,
        pageSizes: [15, 30, 45, 60],
        currentPage: 1
      }
    }
  },
  methods: {
    getRenderColumn(key, title, tip, width = 'auto') {
      return {
        key,
        width,
        align: 'center',
        resizable: true,
        renderHeader: h => this.renderHeader(h, title, tip),
        render: (h, params) => this.renderCol(h, params)
      }
    },
    //查询数据
    searchData(reset) {
      if (reset) {
        this.page.currentPage = 1
      }
      let stime = this.getSecond(this.table.params.dataTime[0])
      let etime = this.getSecond(this.table.params.dataTime[1], false)
      this.timestamp = new Date().getTime()
      let params = this.getTransTopParams('GetNewPlatfromData', {
        app_id: this.table.params.app_id,
        stime,
        etime,
        page: this.page.currentPage,
        limit: this.page.pageSize,
        query_type: 1,
        general: this.table.params.general_id
          ? this.table.params.general_id
          : -1,
        transfer_status: Number(this.table.params.transfer_status),
        transfer_type: Number(this.table.params.transfer_type),
        external_order_id: this.table.params.external_order_id,
        order_no: '',
        pack_no: this.table.params.pack_no
          ? Number(this.table.params.pack_no)
          : -1,
        user_id: Number(this.table.params.user_id),
        superior_id: this.table.params.superior_id
          ? Number(this.table.params.superior_id)
          : -1,
        external_account: this.table.params.external_account,
        superior_name: this.table.params.superior_name,
        external_order_id: this.table.params.external_order_id,
        bill_no: this.table.params.bill_no
      })
      this.table.data = []
      let params1 = this.copyData(params)
      params1.param._func = 'GetUserTransferRecord'

      if (!this.table.params.app_id || this.table.params.app_id == -1) {
        const reqList = []
        const appList = this.getAppList()

        appList.forEach(item => {
          params1.param._param.app_id = item.appid
          reqList.push(TransTopReq(params1))
        })

        Promise.all(reqList).then(values => {
          let lists = []
          values.forEach(item => {
            if (item._param.list) {
              lists = lists.concat(item._param.list)
            }
          })
          this.table.data = lists
        })
      } else {
        params1.param._param.app_id = this.table.params.app_id
        TransTopReq(params1).then(res1 => {
          this.table.data = res1._param.list
          this.page.total = res1._param.total
        })
      }
    },
    renderCol(h, params) {
      let key = params.column.key
      let row = params.row
      if (key === 'transfer_type') {
        const typeItem = this.select.transfer_type.filter(
          item => item.value == row[key]
        )[0]
        return h('span', typeItem.name)
      }
      if (key.indexOf('point') != -1) {
        return this.renderMoney(h, params)
      }
      return this.renderNilData(h, params)
      // return h('span', row[key])
    },
    getTableLength() {
      return Math.max(this.table.data.length - 1, 1)
    },
    getAppList() {
      return this.app_list.filter(el => this.table.params.platid == el.platform)
    },
    getAppGenList() {
      if (!this.table.params.app_id) return
      let params = this.getTransTopParams('GetAppGeneralList', {
        app_id: this.table.params.app_id,
        platid: this.table.params.platid,
        stime: this.getSecond(this.table.params.dataTime[0]),
        etime: this.getSecond(this.table.params.dataTime[1], false),
        page: 1,
        limit: 100,
        sort: 0,
        general: -1,
        pack_no: -1
      })
      this.select.general_list = []
      this.select.pack_list = []
      this.table.params.general_id = -1
      this.table.params.pack_no = -1
      TransTopReq(params).then(res => {
        this.select.general_list = res._param.general_list
        this.table.params.general_id = ''
        let params1 = this.copyData(params)
        params1.param._func = 'GetPackList'
        TransTopReq(params1).then(res => {
          this.select.pack_list = res._param.pack_list || []
        })
      })
    },
    updateGeneral() {
      this.table.params.pack_no = -1
    },
    getPackList() {
      return this.select.pack_list.filter(
        el => el.general == this.table.params.general_id
      )
    },
    //透传接口请求参数 请求方法 请求参数
    getTransTopParams(func, param) {
      return {
        mod: 'root',
        platid: this.table.params.platid,
        app_id: param.app_id,
        app_name: param.app_name,
        timestamp: param.timestamp,
        param: {
          _mod: 'manager',
          _func: func,
          _param: {
            ...param
          }
        }
      }
    },
    updatePlat() {
      this.table.params.app_id = this.getAppList()[0]['appid']
      this.getAppGenList()
    },
    initFunc() {
      this.table.params.platid = this.getinitPlatId()
      this.table.params.app_id = this.app_list.find(
        el => el.platform == this.table.params.platid
      )['appid']
      this.getAppGenList()
    },
    pageChange(page) {
      this.page.currentPage = page
      this.searchData()
    },
    pageSizeChange(size) {
      this.page.pageSize = size
      this.searchData()
    }
  },
  activated() {
    this.initFunc()
    this.searchData()
  },
  mounted() {
    this.tableMaxHeight = window.document.body.clientHeight - 400
  }
}
</script>

<style scoped lang="less">
.tips {
  margin-left: 10px;
  color: red;
  font-size: 12px;
  white-space: nowrap;
}
</style>
